import { useState, type FormEvent } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { post } from '../lib/api'
import { useSession } from '../state/session'
import { Button, ErrorNote, Field } from '../components/ui'

export default function SetPasswordPage() {
  const { user, refresh } = useSession()
  const navigate = useNavigate()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  if (!user) return <Navigate to="/login" replace />

  const forced = user.mustChangePassword

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    if (next !== confirm) {
      setError('The two new passwords do not match')
      return
    }
    if (next.length < 10) {
      setError('Use at least 10 characters')
      return
    }
    setBusy(true)
    setError(null)
    try {
      await post('/api/auth/password', { currentPassword: current, newPassword: next })
      await refresh()
      navigate('/', { replace: true })
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not change your password')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-dvh flex-col justify-center px-5 py-10">
      <div className="mx-auto w-full max-w-sm">
        <p className="label">{forced ? 'One more step' : 'Account'}</p>
        <h1 className="mt-1 mb-2 text-2xl">Choose a password</h1>
        <p className="mb-6 text-sm text-graphite-2">
          {forced
            ? 'Your account was set up with a temporary password. Pick your own to finish.'
            : 'Changing your password signs you out on your other devices.'}
        </p>

        <form onSubmit={submit} className="space-y-4">
          {!forced && (
            <Field label="Current password">
              <input
                className="field"
                type="password"
                autoComplete="current-password"
                required
                value={current}
                onChange={(e) => setCurrent(e.target.value)}
              />
            </Field>
          )}

          <Field label="New password" hint="At least 10 characters">
            <input
              className="field"
              type="password"
              autoComplete="new-password"
              required
              value={next}
              onChange={(e) => setNext(e.target.value)}
            />
          </Field>

          <Field label="New password again">
            <input
              className="field"
              type="password"
              autoComplete="new-password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
          </Field>

          <ErrorNote>{error}</ErrorNote>

          <Button type="submit" variant="primary" size="lg" loading={busy} className="w-full">
            Save password
          </Button>
        </form>
      </div>
    </div>
  )
}
